<template>
  <v-select
    class="vue-select-custom"
    :class="{'vue-select-obat-bhp': keyOpt == 'obat_bhp'}"
    :options="options"
    :error="error"
    :taggable="taggable"
    :value="value"
    :disabled="disabled"
    :clearable="true"
    @search="$emit('search', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    :placeholder="placeholder"
    :selectable="option => !option.disable"
  >
    <template #selected-option="option">
      <div style="display: flex; align-items: baseline">
        <slot name="selected-data" v-bind="option"></slot>
        <slot>{{ option.label }}</slot>
      </div>
    </template>
    <template v-if="keyOpt == 'tindakanBpjs'" slot="selected-option" slot-scope="option">
      {{ option.label ? labelSubstr(option.label, 32) : '-' }}
    </template>
    <template v-if="keyOpt == 'substring'" slot="selected-option" slot-scope="option">
      <label v-tooltip="option.label">{{ option.label ? labelSubstr(option.label, 24) : '-' }}</label>
    </template>
    <template v-if="keyOpt == 'odontogram'" slot="selected-option" slot-scope="option">
      <label class="m-0" v-if="option.label.length < 40">{{ option.label }}</label>
      <label class="m-0" v-else v-tooltip="option.label">{{ option.label ? labelSubstr(option.label, 40) : '-' }}</label>
    </template>
    <template v-if="keyOpt == 'prognosa'" slot="selected-option" slot-scope="option">
      <label class="m-0" v-if="option.label.length < 55">{{ option.label }}</label>
      <label class="m-0" v-else v-tooltip="option.label">{{ option.label ? labelSubstr(option.label, 55) : '-' }}</label>
    </template>
    <template v-if="keyOpt == 'obat_bhp'" slot="option" slot-scope="option">
      <div class="option-obat-bhp d-flex justify-content-between align-items-center w-100">
        <span class="text-start">{{ option.label }}</span>
        <small
          v-if="option && option.is_bpjs == '1'"
          class="text-info-obat text-capitalize ml-4"
        >
          Obat BPJS
        </small>
      </div>
    </template>
  </v-select>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "v-select": () => import("vue-select")
  },
  props: {
    keyOpt: {
      type: String,
      default: ''
    },
    error: Boolean,
    options: {
      type: Array,
      default: () => []
    },
    taggable: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  methods: {
    inputEvent($event) {
      // console.log($event)
    },
    labelSubstr(label, num) {
      if (label.length > num) return label.substring(0, num) + '...';
      return label;
    }
  }
};
</script>

<style lang="scss">
.v-select {
  &.vue-select-custom {
    & > .vs__dropdown-toggle {
      min-height: 41.75px !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
  .vs__dropdown-menu {
    width: 100% !important;
    max-height: 250px !important;
    overflow-y: auto !important;
    overflow-x: auto !important;
    white-space: nowrap !important;
  }
  .vs__dropdown-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100% !important;
    min-width: max-content !important;
    padding-right: 0.75rem;
  }
   .vs__dropdown-option:hover {
    background-color: #6796f4 !important;
    color: #fff !important;
  }

  &.vue-select-obat-bhp {
    .vs__dropdown-menu {
      width: 100% !important;
      max-height: 250px !important;
      overflow-y: auto !important;
      overflow-x: auto !important;
      white-space: nowrap !important;
    }
    .vs__dropdown-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: max-content !important;
      min-width: 100% !important;
      padding-right: 0.75rem;
    }
    .vs__dropdown-option:hover {
      background-color: #6796f4 !important;
      color: #fff !important;
    }
    .text-info-obat {
      padding: 0.1rem 0.5rem;
      color: #333;
      background-color: #6ef881;
      border-radius: 5px;
      flex-shrink: 0;
    }
    .vs__dropdown-option:hover .text-info-obat {
      background-color: #6ef881 !important;
    }
  }
  &.__role-manajemen {
    & > .vs__dropdown-toggle {
      height: 48px !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
  &.custom-v-select-manajemen-tarif {
    & > .vs__dropdown-toggle {
      height: 30px !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
}
</style>
